import { Typography } from "@material-ui/core";

export const TonCo2 = ({ style }) => {
  return (
    <Typography component="span" style={style}>
      tCO
      <Typography style={{ display: "inline", fontSize: 12 }}>2</Typography>
    </Typography>
  );
};
